import { useEffect } from 'react';

import { useActionBar } from '@air/provider-action-bar';
import { useToasts } from '@air/provider-toast';

import { CURRENT_WORKSPACE_NAV_WIDTH } from '~/constants/sideNav';

/**
 * Syncs toast and action bar horizontal offsets with the sidebar state.
 * When the sidebar is open, offsets match its width so toasts/action bars
 * are centered within the board content area.
 */
export const useWorkspaceSidebarOffsets = ({
  isWorkspaceNavPushMode,
  open,
}: {
  isWorkspaceNavPushMode: boolean;
  open: boolean;
}) => {
  const { setToastXOffset } = useToasts();
  const { setActionBarXOffset } = useActionBar();

  useEffect(() => {
    if (isWorkspaceNavPushMode) {
      setToastXOffset(0);
      setActionBarXOffset(0);
    } else if (open) {
      const sidebarWidth =
        parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sidebar-width'), 10) ||
        CURRENT_WORKSPACE_NAV_WIDTH;
      setToastXOffset(sidebarWidth);
      setActionBarXOffset(sidebarWidth);
    } else {
      setToastXOffset(0);
      setActionBarXOffset(0);
    }
  }, [isWorkspaceNavPushMode, open, setToastXOffset, setActionBarXOffset]);

  return { setToastXOffset, setActionBarXOffset };
};
